import useFlag from 'lane-shared/hooks/useFlag';

import { FeatureFlag } from 'constants-flags';

export function useInspectionTemplateCustomizationV2Enabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.InspectionTemplateCustomizationV2,
    false
  );

  return Boolean(isEnabled);
}
